import PropTypes from 'prop-types'
import USBButton from '@usb-shield/react-button'
import { BlockLayout } from '@usb-ui-tools/react-billpay-layout'
import { useMultilingualService } from '../../../../../service/multilingualService'
import {
  isOLBOrIpadApp,
  navigateRoute
} from '../../../../../utils/browserutils'
import { BASE_PATH } from '../../../../../config/connections'
import routerpath from '../../../../../constants/routerpath'
import './find-add-bills.scss'

/**
 * Returns search result of company
 * @method
 * @param {Object} intl - locale of DashboardNearbyMarchants
 * @param {String} paymybillImg - avatar image path
 * @param {Function} setSearchVal - set the search value
 * @param {Object} searchBillData - search bill data
 * @param {Function} setTypeaheadVal - set selected search value
 * @returns {HTMLElement} Returns segment with list of marchants
 */
const DashboardBills = ({
  setFindBillsModal,
  isBillerExist,
  billDiscoveryConsentGiven,
  onAddbillManually,
  billDiscoveryEligible
}) => {
  const { FINDBILLS } = useMultilingualService('addBillDashboard')
  const { navigateRoutePath } = navigateRoute()

  const handleGetStarted = () => {
    if (billDiscoveryConsentGiven) {
      navigateRoutePath(`${BASE_PATH}${routerpath.pages.findbills}`)
    } else {
      setFindBillsModal(true)
    }
  }
  const { ADDBILLS } = useMultilingualService('addBillDashboard')

  const desktopStyle = (style1, style2) => (isOLBOrIpadApp() ? style1 : style2)

  const billerExistfunct = (string1, string2) =>
    isBillerExist ? string1 : string2

  if (billDiscoveryEligible) {
    return (
      <BlockLayout
        actAs="CardChild"
        isOLBOrIpadApp={isOLBOrIpadApp}
        contentDirection="column"
        isCardWithChildren
        compact
        gapOnTop={desktopStyle('24', '16')}
        isMultiColumn={isOLBOrIpadApp()}
        isMultiGrid={!isOLBOrIpadApp()}
      >
        <section
          style={{
            width: '100%',
            display: 'flex',
            minHeight: `${desktopStyle('12.75rem', 'auto')}`,
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <div>
            <p
              id={billerExistfunct(
                'payee-dashboard-addbills-manually-subheader',
                'payee-dashboard-findbills-subheader'
              )}
              className="usb-tg-subheader-large usb-c-usb-blue title"
            >
              {billerExistfunct(ADDBILLS?.TITLE, FINDBILLS?.TITLE)}
            </p>
            <p
              id={billerExistfunct(
                'payee-dashboard-addbills-manually-subtitle',
                'payee-dashboard-findbills-subtitle'
              )}
              className={`usb-tg-body-small usb-c-gray-80
                ${isOLBOrIpadApp() ? 'subtitle-addbills' : ''}`}
            >
              {billerExistfunct(ADDBILLS?.SUBTITLE, FINDBILLS?.SUBTITLE)}
            </p>
          </div>
          <div className={`button ${desktopStyle('', 'button-mbl')} `}>
            <USBButton
              variant="primary"
              size="default"
              id="link"
              handleClick={
                isBillerExist ? onAddbillManually : () => handleGetStarted()
              }
              spacing={{ margin: desktopStyle('0 0 0.5rem', '0') }}
            >
              {billerExistfunct(ADDBILLS?.BUTTONNAME, FINDBILLS?.BUTTONNAME)}
            </USBButton>
          </div>
        </section>
        <section
          style={{
            width: '100%',
            minHeight: `${desktopStyle('12.75rem', 'auto')}`,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <div>
            <p
              id="payee-dashboard-addbills-manually-subheader"
              className="usb-tg-subheader-large usb-c-usb-blue title"
            >
              {billerExistfunct(FINDBILLS?.TITLE, ADDBILLS?.TITLE)}
            </p>
            <p
              id="payee-dashboard-addbills-manually-subtitle"
              className={`usb-tg-body-small usb-c-gray-80
                ${desktopStyle('subtitle-addbills', '')}`}
            >
              {billerExistfunct(FINDBILLS?.SUBTITLE, ADDBILLS?.SUBTITLE)}
            </p>
          </div>
          <div className={`button ${desktopStyle('', 'button-mbl')} `}>
            <USBButton
              variant="secondary"
              size="default"
              id={`${FINDBILLS?.BUTTONNAME}_btn`}
              handleClick={
                isBillerExist ? () => handleGetStarted() : onAddbillManually
              }
              spacing={{ margin: desktopStyle('0 0 0.5rem', '0') }}
            >
              {billerExistfunct(FINDBILLS?.BUTTONNAME, ADDBILLS?.BUTTONNAME)}
            </USBButton>
          </div>
        </section>
      </BlockLayout>
    )
  }
  return (
    <BlockLayout
      actAs="CardChild"
      isOLBOrIpadApp={isOLBOrIpadApp}
      contentDirection="column"
      compact
      gapOnTop={desktopStyle('24', '16')}
    >
      <section
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <p
            id="payee-dashboard-addbills-manually-subheader"
            className="usb-tg-subheader-large usb-c-usb-blue title"
          >
            {ADDBILLS?.TITLE}
          </p>
          <p
            id="payee-dashboard-addbills-manually-subtitle"
            className={`usb-tg-body-small usb-c-gray-80
                ${desktopStyle('subtitle-addbills', '')}`}
          >
            {ADDBILLS?.SUBTITLE}
          </p>
        </div>
        <div className={`button ${desktopStyle('', 'button-mbl')} `}>
          <USBButton
            variant="primary"
            size="default"
            id={`${ADDBILLS?.BUTTONNAME}_btn`}
            handleClick={onAddbillManually}
            spacing={{ margin: desktopStyle('0 0 0.5rem', '0') }}
          >
            {ADDBILLS?.BUTTONNAME}
          </USBButton>
        </div>
      </section>
    </BlockLayout>
  )
}

DashboardBills.propTypes = {
  setFindBillsModal: PropTypes.func.isRequired,
  isBillerExist: PropTypes.bool.isRequired,
  billDiscoveryConsentGiven: PropTypes.bool.isRequired,
  onAddbillManually: PropTypes.func.isRequired,
  billDiscoveryEligible: PropTypes.bool.isRequired
}

export default DashboardBills
